module.exports = {
  fetch: `query getQuestions {
    questions(sortBy: "content.en", filter: { global: { eq: true }}) {
      id
      content {
        en
        es
      }
      global
    }
  }`,
  save: `
    mutation saveQuestion($value: QuestionInput) {
      upsertQuestion(question: $value) {
        id
        content {
          en
          es
        }
      }
    }
  `,
  add: `mutation addQuestion($value: QuestionInput) {
    upsertQuestion(question: $value) {
      id
      content {
        en
        es
      }
    }
  }`,
  bulkAdd: `mutation addQuestions($values: [QuestionInput]) {
    bulkUpsertQuestions(questions: $values) {
      id
      content {
        en
        es
      }
    }
  }
  `,
  remove: `
    mutation removeQuestions($ids: [ID]) {
      bulkRemoveQuestions(ids: $ids)
    }
  `,
};
